"use client"

import { Search } from 'lucide-react'
import { useCommandPaletteStore } from '@/stores/command-palette-store'
import { useComponentsTranslations } from '@/hooks/use-translations'

export function CommandPaletteTrigger() {
  const setOpen = useCommandPaletteStore((s) => s.setOpen)
  const t = useComponentsTranslations()

  return (
    <button
      type='button'
      onClick={() => setOpen(true)}
      className="hidden md:flex items-center w-full max-w-md gap-2 rounded-md border border-input bg-muted/50 px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
    >
      <Search className="h-4 w-4 shrink-0" />
      <span className="flex-1 text-left">{t('command_palette_search')}</span>
      <kbd className="pointer-events-none hidden h-5 select-none items-center gap-1 rounded border bg-background px-1.5 font-mono text-[10px] font-medium sm:flex">
        <span className="text-xs">⌘</span>K
      </kbd>
    </button>
  )
}
